<!-- New Proposal View -->
<template>
  <div>
    <Header />
    <LeftNav />
    <main id="page-wrap">
      <!-- <vue-snotify></vue-snotify> -->
      <b-container fluid>
        <ViewDocument />
      </b-container>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/layout/AppHeader.vue";
import LeftNav from "@/components/common/layout/AppLeftNav";
import ViewDocument from "@/components/proposal/ViewDocument";
import Footer from "@/components/common/layout/AppFooter.vue";

export default {
  name: "NewProposal",
  components: {
    Header,
    LeftNav,
    ViewDocument,
    Footer
  }
};
</script>

<style scoped>
</style>